import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import firebase from 'firebase/compat/app';

@Injectable({
  providedIn: 'root',
})
export class TicketsService {
  private url = environment.urlBackend;

  constructor(private http: HttpClient) {}

  public async getTickets(status: string) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    return this.http
      .get(this.url + 'tickets/bar/' + status, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async getTicket(uidTicket: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    return this.http
      .get(this.url + 'tickets/bar/' + uidTicket, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async getTicketsAccess(status: string) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    return this.http
      .get(this.url + 'tickets/access/' + status, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async getTicketAccess(uidTicket: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    return this.http
      .get(this.url + 'tickets/access/' + uidTicket, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async sendTicketToFriend(id: any, email: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    return this.http
      .post(
        this.url + 'tickets/send/' + id,
        { email },
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async getInfoMenuToUsedTicket(idMenu: any) {
    return this.http.get(this.url + 'tickets/information/' + idMenu, {}).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }
}
